import axiosClient from "./axiosClient";
import API_ENDPOINTS from "../constants/apiEndpoints";

function extractMessage(error, fallback) {
  const d = error?.response?.data;
  const inner = d?.data;
  return (
    inner?.reason ||
    inner?.message ||
    d?.reason ||
    d?.message ||
    error?.message ||
    fallback
  );
}

function unwrapProviderRows(response) {
  const envelope = response?.data?.data ?? response?.data ?? {};
  const rows = envelope?.data ?? [];
  return {
    rows: Array.isArray(rows) ? rows : [],
    message: envelope?.reason || envelope?.message || "Success",
  };
}

/**
 * POST /users/provider-info
 * FormData: consumer_id, user_email
 */
export async function fetchConsumerProviderInfo({ consumerId, userEmail }) {
  if (consumerId == null || !userEmail?.trim()) {
    return {
      status: false,
      message: "Missing account details.",
      data: [],
    };
  }

  const formData = new FormData();
  formData.append("user_id", String(consumerId));
  formData.append("user_email", String(userEmail).trim());

  try {
    const response = await axiosClient.post(API_ENDPOINTS.USER.PROVIDER_INFO, formData, {
      headers: { "Content-Type": "multipart/form-data", Accept: "application/json" },
    });
    const { rows, message } = unwrapProviderRows(response);
    return { status: true, message, data: rows };
  } catch (error) {
    return {
      status: false,
      message: extractMessage(error, "Unable to load provider details."),
      data: [],
    };
  }
}
